import {
    apiRequest,
    excludeAbsenList,
    excludeAbsenActive,
    excludeAbsenInactive
} from "../../../../../services/adapters/kepegawaian/excludeAbsenService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", excludeAbsenList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", excludeAbsenInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", excludeAbsenActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository